import { render, staticRenderFns } from "./StatusIcon.vue?vue&type=template&id=1a2a5cd2"
import script from "./StatusIcon.vue?vue&type=script&lang=js"
export * from "./StatusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports